$(document).ready(function(){


    $('.pruc_carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true, 
        arrows: false,
        autoplay: true, 
        autoplaySpeed: 4000
      });


  $('.pru_faq_cell').click(function(){
    $(this).toggleClass('active');
    $(this).find('.pru_faq_content').slideToggle();
  });


  $('.pru_a_r a').click(function(evt){
    evt.preventDefault();
    $('html, body').animate({
        scrollTop: $(".judgeme_outer_cont").offset().top-200
    }, 500);
  });


  $('.cob_reviews_icons').click(function(evt){
    evt.preventDefault();
    $('html, body').animate({
        scrollTop: $(".judgeme_outer_cont").offset().top-200
    }, 500);
  });


  $('.pm_quest').mouseover(function(){
    $('.pm_note').show();
  });

  $('.pm_quest').mouseleave(function(){
    $('.pm_note').hide();
  });
});